import { Vacancy, VacancyVideosDto } from '@mkp/vacancy/models';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Location } from '@mkp/location/models';

export const vacancyEditActions = createActionGroup({
  source: 'Vacancy Edit Page',
  events: {
    Enter: emptyProps(),
    'Create Location': props<{ location: Location }>(),
    'Delete Location': props<{ locationId: string }>(),
    'Create Vacancy': props<{ vacancy: Vacancy & VacancyVideosDto }>(),
    'Update Publication Ai Usage Consent': props<{ consent: boolean }>(),
  },
});
